import I18nLiteralsValueObject from '../ValueObjects/I18nLiteralsValueObject.js'

export default class I18nValueObjectsFactory {
  static i18nLiteralsValueObject = ({literals} = {}) => new I18nLiteralsValueObject({literals})
}
